import React from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getUserLoansDetail } from 'services/fund'

export default function useGetLoans() {
    const { moneyPool, loanId } = useParams()
    const { data, isLoading } = useQuery(
        ['user-loans-detail-page', moneyPool, loanId],
        getUserLoansDetail
    )
    return { data, isLoading }
}
